<template>
  <nav class="mobile-nav has-primary-background p-t-30 section">
    <figure class="image relative">
      <icon v-if="step1" name="chevron-left" @click.native="step1 = false" style="left: 0px; top: 7px" class="absolute is-white" scale="1.6"></icon>
      <icon name="close" @click.native="$emit('clicked')" class="absolute is-white" scale="1.8"></icon>
        <div class="relative width">
          <img class="img" src="/fstatic/logo-text.svg" alt="">
          <img class="absolute rotate" src="/fstatic/spinner.svg" alt="">
        </div>
    </figure>
    <div class="section m-t-25" :class="{'is-hidden': step1}">
      <h1 class="title is-3 is-white"><router-link :to="'/'">Home</router-link> </h1>
      <h1 class="title is-3 is-white"><router-link :to="'/about'">About Us</router-link> </h1>
      <h1 class="relative title is-3 is-white">Capabilities <icon name="chevron-right" @click.native="show('Capabilities')" class="absolute is-white" scale="1.5"></icon></h1>
      <h1 class="relative title is-3 is-white">Solutions <icon name="chevron-right" @click.native="show('Solutions')" class="absolute is-white" scale="1.5"></icon></h1>
      <h1 class="title is-3 is-white"><router-link :to="'/careers'">Careers</router-link> </h1>  
      <h1 class="title is-3 is-white"><router-link :to="'/contact'">Contact</router-link> </h1>  
    </div>
    <div class="solutions section m-t-25"  v-if="step1 && isSolutionsVisible">
      <solutions-dropdown :solutions="solutions"></solutions-dropdown>
    </div>
    <div class="section m-t-50" :class="{'show':step1}" v-if="step1 && isCapabilitiesVisible">
      <template v-for="capability in capabilities">
          <h1 class="title is-4 is-white"><router-link :to="`/capabilities/${capability.value}`"> <img class="logo" src="/fstatic/spinner.svg">{{capability.value}} </router-link></h1>
      </template>
    </div>
  </nav>
</template>

<script>
import solutionsDropdown from '@/components/utils/solutionsDropdown';

export default {
  components: {
    solutionsDropdown,
  },  
  props: {
    capabilities: {
      type: Array,
      required: true,
    },
    solutions: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      isCapabilitiesVisible: false,
      isSolutionsVisible: false,
      step1: false,
    }
  },
  methods: {
    show(name) {
      this.isCapabilitiesVisible = false;
      this.isSolutionsVisible = false;
      this.step1 = true;
      this.$data[`is${name}Visible`] = true;
    }
  },
  created() {
    document.getElementsByTagName('body')[0].classList.add('no-overflow');
  },
  destroyed() {
    document.getElementsByTagName('body')[0].classList.remove('no-overflow');
  }
}
</script>

<style lang="scss" scoped>
  .width {
    margin: 0 auto;
    width: 150px;
  }
  .hide {
    animation: hide .5s 1;
  }
  .show {
    animation: show .5s 1;
  }
  .title {
    svg {
      top: 6px;
    }
  }
  .section {
    padding: 0rem 1rem;
  }
  svg.absolute {
    right: 0px;
  }
  .mobile-nav {
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    width: 100%;
    overflow: scroll;
    background: gray;
    z-index: 99999;
    animation: mymove 1s 1;
  }
  @keyframes mymove {
    0% {
      left: -100vw;
    }
    100% {
      left: 0vw;
    }
  }
  .p-t-30 {
    padding-top: 30px;
  }
  figure {
    margin-left: 10px;
  }
  .img {
    width: 150px;
    height: auto;
  }
  img.absolute {
    top: -20px;
    left: -30px;
    width: 35px;
  }
.no-overflow {
  overflow: hidden;
  height: 100vh;
}
  .rotate {
    animation: rotate 2.5s infinite;
  }
  @keyframes rotate {
    0% {
      transform: rotate(-180Deg);
    }
    100% {
      transform: rotate(180Deg);
    }
  }
  @keyframes hide {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes show {
    0% {
      position: relative;
      opacity: 0;
      left: -100vw !important;
    }
    100% {
      opacity: 1;
      position: relative;
      left: 0vw !important;
    }
  }
  .logo {
    height: 25px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// mobileNavbar.vue?53a3d862